"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verify = exports.getSecretKeyFromKeystore = void 0;
var _utils = require("./utils");
var _crypto = require("crypto");
var _ethereumjsUtil = require("ethereumjs-util");
var _scryptJs = require("scrypt-js");
const getDerivedKey = async (keystore, password) => {
  password = (0, _utils.normalizePassword)(password);
  let derivedKey;
  if (keystore.crypto.kdf.function === _utils.KDFFunctions.Scrypt) {
    const kdfparams = keystore.crypto.kdf.params;
    derivedKey = await (0, _scryptJs.scrypt)(Buffer.from(password), Buffer.from(kdfparams.salt, 'hex'), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen);
    derivedKey = Buffer.from(derivedKey);
  } else if (keystore.crypto.kdf.function === _utils.KDFFunctions.PBKDF) {
    const kdfparams = keystore.crypto.kdf.params;
    derivedKey = (0, _crypto.pbkdf2Sync)(Buffer.from(password), Buffer.from(kdfparams.salt, 'hex'), kdfparams.c, kdfparams.dklen, 'sha256');
  }
  return derivedKey;
};
const verify = async (keystore, password) => {
  const derivedKey = await getDerivedKey(keystore, password);
  const checksum = (0, _ethereumjsUtil.sha256)(Buffer.concat([derivedKey.slice(16), Buffer.from(keystore.crypto.cipher.message, 'hex')])).toString('hex');
  return checksum === keystore.crypto.checksum.message;
};
exports.verify = verify;
const getSecretKeyFromKeystore = async (keystore, password) => {
  const derivedKey = await getDerivedKey(keystore, password);
  const checksum = (0, _ethereumjsUtil.sha256)(Buffer.concat([derivedKey.slice(16), Buffer.from(keystore.crypto.cipher.message, 'hex')])).toString('hex');
  if (checksum !== keystore.crypto.checksum.message) return Promise.reject('invalid password');
  const ciphertext = (0, _crypto.createDecipheriv)(keystore.crypto.cipher.function, derivedKey.slice(0, 16), Buffer.from(keystore.crypto.cipher.params.iv, 'hex'));
  const key = (0, _utils.runCipherBuffer)(ciphertext, Buffer.from(keystore.crypto.cipher.message, 'hex'));
  return key;
};
exports.getSecretKeyFromKeystore = getSecretKeyFromKeystore;